<template>

<!-- UI -->
<nav class="custom-nav blue-grey darken-3 hide-on-small-only"></nav>

<nav class="nav-extended blue-grey darken-3 hide-on-small-only">
  <div class="nav-wrapper container">
    <a href="#!" class="brand-logo" @click.prevent="handleActive(home)">{{ home?.name }}</a>
    <ul class="right hide-on-med-and-down">
      <li v-for="tab in tabs" :key="tab.id" :class="{ 'active active blue-grey darken-2': tab.id == currTab.id }"><a href="#"
          @click.prevent="handleActive(tab)">{{ tab.title
          }}</a>
      </li>
    </ul>
  </div>
  <div class="nav-content container">
    <br />
  </div>
</nav>

 <!-- Mobile only -->
  <nav class="blue-grey darken-3 hide-on-large-only">
      <ul class="tabs tabs-transparent">
        <li v-for="tab in tabs" :key="tab.id" class="tab" :class="{ 'active': tab.id == currTab.id }">
          <a href="#" @click.prevent="handleActive(tab)" v-if="shorts">{{ tab?.title?.split(" ")[0] }}</a>
          <a href="#" @click.prevent="handleActive(tab)" v-else>{{ tab.title }}</a>
        </li>
      </ul>
  </nav>

  <!-- Search Nav -->
<nav class="nav-extended blue-grey darken-3">
    <div class="nav-wrapper blue-grey darken-3 container z-depth-4">
      <form>
        <div class="input-field">
          <input id="search" type="search" v-model="searchItem" placeholder="Search Hospital by Name, Address">
          <label class="label-icon" for="search"><i class="material-icons">search</i></label>
          <i class="material-icons white-text orange" @click="handleClearSearch" v-if="searchItem">clear</i>
        </div>
      </form>
    </div>
  </nav>

<!-- Loader -->
<div class="container progress" v-if="isLoading && isReady">
  <div class="indeterminate"></div>
</div>

 <!-- breadcrumbs -->
  <nav class="grey lighten-4 z-depth-0">
    <div class="container nav-wrapper">
      <div class="col s12">
        <router-link to="/" class="breadcrumb teal-text"><small> <i class="material-icons left">home</i> Dashboard</small></router-link>
        <span class="breadcrumb blue-grey-text pointable"><small>Healthcare Home</small></span>
      </div>
    </div>
  </nav>

<!-- search layer -->
<!-- <div class="grey lighten-4">
  <div class="container section"></div>
</div> -->

<!-- View Marker -->
<div id="view"></div>


<!-- Main -->
  <div class="container">

    <LoadingDiv v-if="!isReady" />

    <div v-else>

      <br />

      <PaginationDiv :payLoad="allPages" @newPage="handlePage" v-if="providers.length" />

      <div class="section">
        <div class="card-panel z-depth-0 grey lighten-5" v-for="provider in providers" :key="provider.id">
          <h5>{{ provider.name }}</h5>
          <h6 class="grey-text darken-4">{{ provider.address }}</h6>
          <p>{{ provider.phone }} {{ provider.user?.email }}</p>
        </div>
      </div>

      <div class="section center" v-if="!providers.length">
        <h6>No Provider <em>found</em>...</h6>
      </div>

      <PaginationDiv :payLoad="allPages" @newPage="handlePage" v-else />
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
// import { useStore } from "vuex";
import getItems from "@/composables/getItems";
import LoadingDiv from "@/components/LoadingDiv.vue";
import PaginationDiv from "@/components/pager/PaginationDiv.vue";
import { debounce, getCachedPayload, setCachedPayload } from "@/composables/requestOptimization";

export default {
  name: "enrolleeHome",
  components: { LoadingDiv, PaginationDiv },
  setup() {
    const response = ref(null);
    const isReady = ref(false);
    const isLoading = ref(true);
    const currUrl = ref(null);
    const currHook = ref(null);
    const serverTime = ref(null);
    const error = ref(null);
    const searchItem = ref(null);
    const home = ref(null);
    const currTab = ref(null);
    const tabs = ref([]);
    const providerSearchCacheTtl = 60 * 1000;
    let providerSearchRequestId = 0;

    // vue router
    const router = useRouter();

     // store
    // const store = useStore();

    // client ID
    // const clientId = store.state?.user?.account?.id;

    // start
    onMounted(() => {
      // page name
      document.title = "Healthcare facilities";
    });

    // menu
    onMounted(() => {
      // load tab
      tabs.value.push({ id: 1, name: "Healthcare Facilities", title: "Home", icon: null, url: "healthcare", hash: null, });

      // set default
      currTab.value = tabs.value.find(x => x.title.includes("Home"));
      // set home
      home.value = tabs.value.find(x => x.title.includes("Home"));
    });

    // handle curr status
    const handleActive = (tab) => {
      // refer
      if (tab.hash) {
        router.push({ name: tab.url, hash: tab.hash });
      } else {
        router.push({ name: tab.url });
      }
    };

    // numbering
    const numberBadge = (num) => {
      return (
        (allPages.value.current_page - 1) * allPages.value.per_page + num + 1
      );
    };

    const inDays = (val) => {
      if (val && serverTime.value) {
        const date1 = new Date(val);
        const date2 = new Date(serverTime.value);
        const diffTime = Math.abs(date2 - date1);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays;
      } else {
        return -1;
      }
    };

    // get function
    const getItemsFromApi = (table) => {
      (async () => {
        const { res, err } = await getItems(table);

        if (res.value) {
          response.value = res.value.data;
          serverTime.value = res.value.server;
        } else {
          error.value = err.value;
        }

        // page is ready, loading is complete
        isReady.value = true;
        isLoading.value = false;
      })();
    };

    // starter
    onMounted(() => {
      // set current Url
      currUrl.value = "provider";
      // set current Hook
      currHook.value = "?";
      // get items from function
      getItemsFromApi(currUrl.value);
    });

    // restart
    const handleClearSearch = () => {
      providerSearchRequestId++;
      // start laoding
      isLoading.value = true;
      // null search
      searchItem.value = null;
      // set current Url
      currUrl.value = "provider";
      // set current Hook
      currHook.value = "?";
      // re-get items from function
      getItemsFromApi(currUrl.value);
    };

    const loadProviderSearch = debounce(async (query, requestId) => {
      if (requestId !== providerSearchRequestId || query !== searchItem.value?.trim()) {
        return;
      }

      const url = `provider/list/search?q=${encodeURIComponent(query)}`;
      const cachedPayload = getCachedPayload(url);

      if (cachedPayload) {
        response.value = cachedPayload;
        isReady.value = true;
        isLoading.value = false;
        return;
      }

      const { res, err } = await getItems(url);

      if (requestId !== providerSearchRequestId || query !== searchItem.value?.trim()) {
        return;
      }

      if (res.value) {
        response.value = res.value.data;
        setCachedPayload(url, res.value.data, providerSearchCacheTtl);
      } else {
        error.value = err.value;
      }

      isReady.value = true;
      isLoading.value = false;
    });

    // switch page
    const handlePage = (page) => {
      // start laoding
      isReady.value = false;
      // get new page items from function
      getItemsFromApi(`${currUrl.value}${currHook.value}page=${page}`); //
    };

    // search watcher
    watch(searchItem, (value) => {
      const query = value?.trim() || "";
      providerSearchRequestId++;

      if (!query) {
        return;
      }

      if (query.length < 2) {
        isLoading.value = false;
        return;
      }

      // start laoding
      isLoading.value = true;
      // set current Url
      currUrl.value = `provider/list/search?q=${encodeURIComponent(query)}`;
      // set current Hook
      currHook.value = "&";
      // get searchItem items from function
      loadProviderSearch(query, providerSearchRequestId);
    });

    // output results
    const providers = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value.data;
      }
    });

    // output pages
    const allPages = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value; // get all
      }
    });

    return {
      handleActive,
      home,
      currTab,
      tabs,
      numberBadge,
      handleClearSearch,
      handlePage,
      inDays,
      isReady,
      isLoading,
      error,
      searchItem,
      providers,
      allPages,
    };
  },
};
</script>

<style scoped>
.progress {
  margin-top: -10px;
}
.custom-nav {
  height: 15px;
}

/* .nav-extended .nav-wrapper {
  padding: 0 20px;
} */

.brand-logo {
  font-weight: 300;
  font-size: 1.5rem;
}

.nav-wrapper ul li a {
  font-weight: 400;
  padding: 0 15px;
}

.nav-content {
  min-height: 20px;
}
</style>
